export default __webpack_public_path__ + "static/media/medocta-icon.5018d8c8.svg";